import Create from './create/CreateMerch';
import Edit from './edit/EditMerch';
import Individual from './individual/Merch';
import List from './list/MerchList';

export default { List, Individual, Create, Edit };
